module.exports = __webpack_public_path__ + "img/faceoffpittkentstate_thumb.d82c9ba6.jpg";